<template>
  <div>
    <v-card
      class="mb-5 pa-5"
      data-cy="card_solicitacao_reembolso"
    >
      <p
        class="primary--text mb-4 subtitle-2 font-weight-bold text-uppercase text-center"
        data-cy="card_titulo_solicitacao_reembolso"
      >
        Solicitação de Reembolso
      </p>

      <p class="mb-5 grey--text text--darken-2">
        Acompanhe aqui o processo de análise da sua solicitação de reembolso.
      </p>

      <p
        class="d-flex"
        :class="corStatus(true)"
      >
        <v-icon
          class="mr-2"
          :color="corStatus()"
        >
          {{ iconeStatus }}
        </v-icon>

        <span data-cy="status_do_reembolso">
          {{ statusReembolso }}
        </span>
      </p>

      <a
        v-if="dadosDaCompra.refund_request_retry_limit_reached"
        href="mailto:suporte@monetizze.com.br"
        class="text-decoration-none"
      >
        <v-alert
          href="mailto:suporte@monetizze.com.br"
          color="orange"
          dark
          dense
          data-cy="informacao_tentativas_excedidas"
        >
          Você excedeu o número de tentativas para correção dos dados bancários, mas não se
          preocupe, o seu reembolso será feito. Pedimos que entre em contato com o
          <strong>suporte@monetizze.com.br</strong>
          encaminhando seus dados bancários de forma manual.
        </v-alert>
      </a>

      <p
        v-if="dadosDaCompra.refunded_at"
        class="mb-5 grey--text text--darken-2"
      >
        Reembolso realizado em
        {{ dadosDaCompra.refunded_at | dataFormatada('numeric', '2-digit', '2-digit') }}
      </p>

      <v-btn
        v-if="enableBtnCorrigir"
        block
        outlined
        class="mb-4"
        color="primary"
        data-cy="btn_corrigir"
        :to="`/solicitacao-de-reembolso/corrigir-dados-bancarios`"
      >
        Corrigir
      </v-btn>

      <v-btn
        v-if="!enableBtnCorrigir"
        block
        outlined
        class="mb-4"
        color="primary"
        data-cy="btn_acompanhar_reembolso"
        :to="`/acompanhar-solicitacao-reembolso/${codigoCompra}/${codigoReembolso}`"
        :disabled="disabledBtnsReembolso()"
      >
        {{
          'Acompanhar' |
            changeText(dadosDaCompra.refund_request_status_slug, statusChangeText)
        }}
      </v-btn>

      <ModalDesistir
        :status-reembolso="statusReembolsoSlug"
        :codigo-reembolso="dadosDaCompra.refund_request_id"
        :codigo-venda="dadosDaCompra.id"
        :disable-btn="disabledBtnsReembolso()"
        @repostaApi="mesangemConfirmacao"
      >
        <template v-slot:texto>
          Ao cancelar sua solicitação de reembolso pela Plataforma Monetizze,
          você está ciente que o prazo de arrependimento (
          <strong>
            {{ dadosDaCompra.warranty_days }}
          </strong>
          dias contados da data da compra)
          continuará a correr. Assim, caso ainda esteja dentro do prazo
          e queira pedir novamente a devolução do valor pago,
          entre em contato com o Suporte Monetizze pelo e-mail: suporte@monetizze.com.br.
        </template>
      </ModalDesistir>
    </v-card>
  </div>
</template>

<script>

import ModalDesistir from '@/components/Compras/ModalDesistir.vue';

export default {
  name: 'CardSolicitacaoReembolso',

  components: {
    ModalDesistir,
  },

  filters: {
    changeText(acompanhar, status, statusChangeText) {
      const found = statusChangeText.includes(status);
      if (!found) return acompanhar;

      return 'Responder vendedor';
    },
  },

  props: {
    dadosDaCompra: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      statusDoReembolso: {
        sucesso: ['reembolso-processado'],
        cancelado: ['reembolso-cancelado'],
      },
      statusBtnDesativados: ['aguardando-estorno', 'reembolso-cancelado', 'reembolso-processado'],
      statusChangeText: ['aguardando-resposta-consumidor', 'aguardando-devolucao-produto'],
    };
  },

  computed: {
    statusReembolso() {
      return this.dadosDaCompra.refund_request_status;
    },

    statusReembolsoSlug() {
      return this.dadosDaCompra.refund_request_status_slug;
    },

    codigoReembolso() {
      return this.dadosDaCompra.refund_request_id;
    },

    codigoCompra() {
      return this.dadosDaCompra.id;
    },

    iconeStatus() {
      const status = this.dadosDaCompra.refund_request_status_flag;
      if (status === 'warning') return 'error';
      if (status === 'success') return 'check_circle';
      return 'cancel';
    },
    enableBtnCorrigir() {
      return this.dadosDaCompra.refund_request_status_slug === 'aguardando-dados-consumidor';
    },

  },

  methods: {
    corStatus(possuiTexto = false) {
      const flag = this.dadosDaCompra.refund_request_status_flag;
      const texto = possuiTexto ? '--text' : '';

      return flag + texto;
    },

    mesangemConfirmacao(sucesso) {
      this.showSnackBar = true;

      if (sucesso) {
        this.$emit('atualizarDados', {
          message: 'Solicitação de reembolso cancelada com sucesso.',
          color: 'success',
        });
      } else {
        this.$emit('mostrarSnackBar', {
          message: 'Tente novamente mais tarde.',
          color: 'error',
        });
      }
    },

    disabledBtnsReembolso() {
      const status = this.dadosDaCompra.refund_request_status_slug;
      const found = this.statusBtnDesativados.includes(status);
      if (found) return true;

      return false;
    },
  },

};
</script>
